import { _Avatar } from "./_Avatar";
import { AvatarBaseProps } from "./types";

type Props = Pick<
  AvatarBaseProps,
  "size" | "testID" | "displayVerifiedBadge"
> & {
  image: React.ReactNode;
};

export function ImageAvatar({ testID = "image-avatar", ...props }: Props) {
  return (
    <_Avatar {...props} backgroundColor="surface-base" testID={testID}>
      {props.image}
    </_Avatar>
  );
}
